/**
 * FAQ for candidates (Kandidaten) – Headhunting / Vermittlung aus Kandidatensicht.
 * Used on the FAQ für Kandidaten page (navbar: Kandidaten → FAQ).
 */
export const FAQ_FOR_CANDIDATES = [
  {
    question: "Kostet mich die Vermittlung etwas?",
    answer:
      "Nein. Unsere Leistung wird vom Arbeitgeber (Mandanten) getragen. Für Sie als Kandidat oder Kandidatin entstehen keine Kosten – weder für das Kennenlerngespräch noch für die Vermittlung oder die Begleitung durch die weiteren Schritte.",
  },
  {
    question: "Wird mein aktueller Arbeitgeber informiert?",
    answer:
      "Nein. Wir behandeln alle Gespräche strikt vertraulich. Ihr Arbeitgeber wird von uns nicht informiert. Eine Weitergabe von Informationen an Dritte erfolgt nur mit Ihrer ausdrücklichen Zustimmung, z.B. wenn wir Sie bei einem konkreten Mandanten vorstellen möchten.",
  },
  {
    question: "Wie läuft das weitere Vorgehen nach dem ersten Kontakt ab?",
    answer:
      "Nach einem ersten Kennenlerngespräch (per Telefon oder persönlich) prüfen wir, ob es passende Mandate für Ihr Profil gibt. Nur wenn Sie einverstanden sind, vermitteln wir Sie beim Arbeitgeber und begleiten Sie durch Vorstellungsgespräche und – bei Interesse – bis zur Vertragsunterzeichnung. Sie entscheiden in jedem Schritt mit.",
  },
  {
    question: "Was passiert mit meinen Daten?",
    answer:
      "Ihre Daten werden ausschließlich für die Vermittlung und die Kommunikation mit Ihnen verwendet. Wir verarbeiten sie im Einklang mit der DSGVO und geben sie nur mit Ihrer Zustimmung an Mandanten weiter. Ohne Ihr Einverständnis erfolgt keine Weitergabe.",
  },
  {
    question: "Für welche Positionen und Branchen vermitteln Sie?",
    answer:
      "Wir vermitteln Fach- und Führungskräfte im Gesundheitswesen: z.B. Ärztinnen und Ärzte, Klinikleitungen, Spezialisten aus Pharma und Medizintechnik sowie Positionen in MVZ und Praxen. Unser Fokus liegt auf dem Healthcare-Bereich in Deutschland und auf Wunsch auch international.",
  },
  {
    question: "Muss ich mich aktiv bewerben oder werden Sie auf mich zukommen?",
    answer:
      "Beides ist möglich. Viele Kandidaten werden von uns im Rahmen der Direktansprache kontaktiert, weil ihr Profil zu einer offenen Position passt. Sie können sich aber auch initiativ bei uns melden, etwa über unsere Kontaktseite oder per E-Mail. Wir prüfen dann, ob wir Sie bei passenden Mandaten einbeziehen können.",
  },
  {
    question: "Kann ich eine Vermittlung ablehnen oder pausieren?",
    answer:
      "Ja. Sie sind zu nichts verpflichtet. Sie können ein Angebot oder eine Vorstellung jederzeit ablehnen oder wünschen, dass wir Ihre Unterlagen vorübergehend nicht weiterreichen. Wir respektieren Ihre Entscheidung und bleiben diskret.",
  },
];
